import { render, staticRenderFns } from "./FireStationTableForm.vue?vue&type=template&id=3fb67b74&scoped=true"
import script from "./FireStationTableForm.vue?vue&type=script&lang=js"
export * from "./FireStationTableForm.vue?vue&type=script&lang=js"
import style0 from "./FireStationTableForm.vue?vue&type=style&index=0&id=3fb67b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb67b74",
  null
  
)

export default component.exports